import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StudentMaintenanceService {

  public studentId: number;
  public clientIdFilter: number;

  constructor() { }
}
